import React from 'react'
import { IonCol, IonRow } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getPatientMedicalHistorySelector } from '../../selectors'
import { IOption } from '../../../../common/common.types'
import { getPatientMedicalHistoryOptionsSelector } from '../../../options/selectors'
import { setEmergencyInfoForm, setObtainedFrom } from '../../store/patientMedicalHistory.actions'
import SingleSelect from '../../../../components/singleSelect/SingleSelect.component'
import MultiSelect from '../../../../components/multiSelect/MultiSelect.component'
import _ from 'lodash'

const MedicalHistoryForm: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const patientMedicalHistory = useSelector(getPatientMedicalHistorySelector)
  const { obtainedFrom, emergencyInfoForm, medicalHistoryPNNV } = patientMedicalHistory
  const patientMedicalHistoryOptions = useSelector(getPatientMedicalHistoryOptionsSelector)
  const { obtainedFromOptions, emergencyInfoFormOptions } = patientMedicalHistoryOptions

  const setEmergencyInfoFormOnChange = (option: IOption) => {
    dispatch(setEmergencyInfoForm(option))
  }

  return (
    <>
      <hr className='field-divider' />
      <IonRow>
        <IonCol className='picklist'>
          <MultiSelect
            dataTestID='ObtainedFrom'
            label={t('patientMedicalHistory.ObtainedFrom')}
            listHeader={t('patientMedicalHistory.ObtainedFrom')}
            options={obtainedFromOptions}
            savedValues={obtainedFrom}
            action={setObtainedFrom}
            showChips={true}
            disabled={!_.isEmpty(medicalHistoryPNNV)}
          />
        </IonCol>
      </IonRow>
      <hr className='field-divider' />

      <IonRow>
        <IonCol className='picklist'>
          <SingleSelect
            dataTestID='EmergencyInfoForm'
            options={emergencyInfoFormOptions}
            selectedOption={emergencyInfoForm}
            listHeader={t('patientMedicalHistory.EmergencyInfoForm')}
            label={t('patientMedicalHistory.EmergencyInfoForm')}
            action={setEmergencyInfoFormOnChange}
            disabled={!_.isEmpty(medicalHistoryPNNV)}
          />
        </IonCol>
      </IonRow>
      <hr className='field-divider' />
    </>
  )
}

export default MedicalHistoryForm
